import type { CSSProperties } from 'react';

/** Shared preview footprints used throughout the dashboard. */
export const PREVIEW_SIZES = {
  table: { width: 180, height: 120, imageWidth: 360, aspectRatio: '3/2' },
  inline: { width: 240, height: 160, imageWidth: 480, aspectRatio: '3/2' },
  expanded: { width: 320, height: 180, imageWidth: 640, aspectRatio: '16/9' },
} as const;

export type PreviewSize = keyof typeof PREVIEW_SIZES;

/** Resolves a preview size preset into inline styles for its framed footprint. */
export function getPreviewFrameStyle(
  size: PreviewSize,
  fluid = false,
): CSSProperties {
  const dimensions = PREVIEW_SIZES[size];

  return fluid
    ? { width: '100%', aspectRatio: dimensions.aspectRatio }
    : { width: dimensions.width, height: dimensions.height, flexShrink: 0 };
}
